export default "__VITE_PUBLIC_ASSET__076abb29__"